import React, { useState, useEffect } from 'react';
import './Hero.css';

const Hero = () => {
  const [displayedText, setDisplayedText] = useState('');
  const [isTyping, setIsTyping] = useState(true);
  const [showCursor, setShowCursor] = useState(true);

  useEffect(() => {
    const phases = [
      { action: 'type', text: "Hi, I'm Josh Wentezll", speed: 100 }, // Type with typo
      { action: 'pause', duration: 800 }, // Pause to "notice" the mistake
              { action: 'backspace', count: 4, speed: 250 }, // Backspace "ezll" (4 chars) - slower, more deliberate
              { action: 'type', text: "zell", speed: 225 }, // Type correct ending - slow and deliberate
      { action: 'complete' } // Mark as finished
    ];

    let phaseIndex = 0;
    let currentText = '';
    let charIndex = 0;

    const executePhase = () => {
      if (phaseIndex >= phases.length) return;
      
      const currentPhase = phases[phaseIndex];

      if (currentPhase.action === 'type') {
        if (charIndex < currentPhase.text.length) {
          currentText += currentPhase.text[charIndex];
          setDisplayedText(currentText);
          charIndex++;
          setTimeout(executePhase, currentPhase.speed);
        } else {
          // Move to next phase
          phaseIndex++;
          charIndex = 0;
          setTimeout(executePhase, 100);
        }
      } 
      else if (currentPhase.action === 'pause') {
        setTimeout(() => {
          phaseIndex++;
          executePhase();
        }, currentPhase.duration);
      }
      else if (currentPhase.action === 'backspace') {
        if (charIndex < currentPhase.count) {
          currentText = currentText.slice(0, -1); // Remove last character
          setDisplayedText(currentText);
          charIndex++;
          setTimeout(executePhase, currentPhase.speed);
        } else {
          // Move to next phase
          phaseIndex++;
          charIndex = 0;
          setTimeout(executePhase, 100);
        }
      }
      else if (currentPhase.action === 'complete') {
        setIsTyping(false);
      }
    };

    const timer = setTimeout(executePhase, 500); // Initial delay
    return () => clearTimeout(timer);
  }, []);

  // Cursor blinking effect
  useEffect(() => {
    const cursorTimer = setInterval(() => {
      setShowCursor(prev => !prev);
    }, 530);
    return () => clearInterval(cursorTimer);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              <span className="typing-text">
                {displayedText === "Hi, I'm Josh Wentzell" ? (
                  <>Hi, I'm <span className="highlight">Josh Wentzell</span></>
                ) : (
                  displayedText
                )}
                <span className={`typing-cursor ${isTyping && showCursor ? 'visible' : ''}`}>|</span>
              </span>
            </h1>
            <h2 className="hero-subtitle">
              Solutions Architect, Office of the CTO
            </h2>
            <p className="hero-description">
              I design and implement scalable enterprise solutions, specializing in automation, 
              infrastructure orchestration, and cutting-edge technologies. Passionate about driving 
              efficiency through innovative system design and automation.
            </p>
            <div className="hero-buttons">
              <button 
                onClick={() => scrollToSection('projects')} 
                className="btn btn-primary"
              >
                View My Work
              </button>
              <button 
                onClick={() => scrollToSection('contact')} 
                className="btn btn-secondary"
              >
                Get In Touch
              </button>
            </div>
          </div>
          <div className="hero-image">
            <div className="profile-photo">
              <img 
                src="/profile.jpg" 
                alt="Josh Wentzell - Solutions Architect" 
                className="profile-img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;